import { StyleSheet } from '@/core/StyleSheet';

export default {
	default: StyleSheet.create({
		content: {
			color: '$linkColor',
			fontSize: '$linkFontSize',
		},
	}),

	default__isDisabled: StyleSheet.create({
		content: {
			opacity: 0.4,
		},
	}),
};
